/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext, useRef } from "react";
import { Redirect, Route, useLocation } from 'react-router-dom';
import { FitinsurAPI } from "utils";
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';
import LoadingPage from "containers/loadingPage";
import Error403Page from "containers/error403";
import Routes from "constants/Routes";
import Access from "constants/Access";
import {
    LoaderContext
} from '@fitinsur/contexts'
import { useTextMessage } from '@fitinsur/hooks';

export default function PrivateRoute(props) {
    const {
        component: Component,
        path,
        routePermissions,
        routeTextMessages
    } = props;

    const authContext = useContext(GlobalAuthContext);
    const location = useLocation();
    const fitinsurApi = new FitinsurAPI();
    const { updateIsLoadingStatus } = useContext(LoaderContext);
    const { getTextMessages, textMessages } = useTextMessage();

    const [permissions, setPermissions] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [isForbiddenRoute, setIsForbiddenRoute] = useState(false);

    useEffect(() => {
        getPermissions();

        if (routeTextMessages) {
            const filteredModels = routeTextMessages.models.map((model) => {
                return {
                    modelName: model.modelName,
                    modelItemIds: model.modelItemIds.filter((id) => !Object.keys(textMessages?.[model.modelName] || {}).includes(id.toString()))
                }
            })
    
            const nonEmptyModels = filteredModels.filter((model) => model.modelItemIds.length > 0);

            if (nonEmptyModels.length > 0) {
                getTextMessages({
                    domainIds: routeTextMessages.domainIds,
                    models: nonEmptyModels,
                    isoCode: authContext.region,
                });
            }
        }
    }, [props.location.pathname]);

    useEffect(() => {
        updateIsLoadingStatus(isLoading);
    }, [isLoading])

    async function getPermissions() {
        //TODO: descomentar quando implementar todas as rotas
        if (!routePermissions) return setIsLoading(false);

        setIsLoading(true);

        //check application access
        const hasApplicationAccess = await getApplicationAccess();
        if (!hasApplicationAccess) {
            setIsForbiddenRoute(true);
            setIsLoading(false);
        }

        //check page access
        let userPermissions = {};
        if (typeof routePermissions === "number") {
            const response = await fitinsurApi
            .requestAccess("", "READ", routePermissions, null, null, authContext.token)
            .then((response) => response.json());
            userPermissions["permission"] = response.ret_code === 200 ? routePermissions : false;
            if (!userPermissions.permission){
                setIsForbiddenRoute(true);
                setIsLoading(false);
            }
        } else {
            const arrayIdDomains = Object.entries(routePermissions)
            const idsDomain = arrayIdDomains.map(item => item[1]);

            const response = await fitinsurApi
                .requestAccess("", "READ", idsDomain, null, null, authContext.token)
                .then((response) => response.json());

            let auxIdsDomainsAllowed = {}; 
            response.ret_value.role.map((r, index) => {
                
                const foundEntry = Object.entries(routePermissions).find(
                    ([key, value]) => value === r.idDomain && r.allowed
                  );

                if(foundEntry) {
                    auxIdsDomainsAllowed = {...auxIdsDomainsAllowed, [foundEntry[0]]: foundEntry[1]}
                }

                return auxIdsDomainsAllowed;
            })            

            userPermissions["permission"] = auxIdsDomainsAllowed;
            
        }

        if (userPermissions.READ != null && !userPermissions.READ) setIsForbiddenRoute(true);
        console.log("userPermissions", userPermissions);
        setPermissions(userPermissions.permission);
        setIsLoading(false);
    }

    async function getApplicationAccess() {
        const response = await fitinsurApi
            .requestAccess("", "READ", Access.APLICATION, null, null, authContext.token)
            .then((response) => response.json());

        if (response.ret_code !== 200) {
            return false;
        }

        return true;
    }

    return (
        <Route path={path} render={() => {
            if (isForbiddenRoute) return <Error403Page />;
            if (authContext.status) return <Component {...props} match={props.computedMatch} permissions={permissions || {}} />;
            return <Redirect to={`${Routes.LOGIN}?redirect=${props.location.pathname}`} />
        }} />
    )
}